import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import DryRunScheduleList from "./DryRunScheduleList";
import DryRunScheduleShow from "./DryRunScheduleShow";
import DryRunScheduleCreate from "./DryRunScheduleCreate";
import DryRunScheduleEdit from "./DryRunScheduleEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "dryRunSchedules",
  list: DryRunScheduleList,
  show: DryRunScheduleShow,
  create: DryRunScheduleCreate,
  edit: DryRunScheduleEdit,
  icon: PlayCircleFilledIcon,
};
